/** Общая идентичность для SWR, прогрева ссылок и SSR-прогрева старых /view. */
export function dataCacheIdentity(userId: string | null | undefined, accountId: string | null | undefined): string {
  return JSON.stringify([userId ?? null, accountId ?? null]);
}

/** Строка начинается с URL: существующие mutate-фильтры /api/products работают. */
export function dataCacheKey(url: string, identity?: string): string {
  return identity ? `${url}#frogstat=${encodeURIComponent(identity)}` : url;
}
